/**
 *  @class
 *  @function TermsCheckbox
 */
if (!customElements.get('terms-checkbox')) {
  class TermsCheckbox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.append = this.dataset.append;
      this.terms_checkbox = this.querySelector(`#CartTerms${this.append}`);
      this.checkout_button = this.parentNode.querySelector('.button.checkout-button');
      this.enableOrDisableSubmitBtn();
      if (this.terms_checkbox && this.checkout_button) {
        this.terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
        this.terms_checkbox.addEventListener('change', e => {
          this.enableOrDisableSubmitBtn();
        })
        this.checkout_button.addEventListener('click', (e) => {
          if (!this.terms_checkbox.checked) {
            this.terms_checkbox.reportValidity();
            this.terms_checkbox.focus();
            e.preventDefault();
          }
        });
      }
    }

    enableOrDisableSubmitBtn() {
      if (!this.terms_checkbox.checked) {
        this.checkout_button.disabled = true;
      } else {
        this.checkout_button.disabled = false;
      }
    }
  }
  customElements.define('terms-checkbox', TermsCheckbox);
}
